angular.module('forms').directive('apFormAnswerText',
    ['$rootScope',
        function ($rootScope) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormAnswerText.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    question: '=question',
                    answer: '=answer',
                    lastQuestion: '@lastQuestion'
                },
                controller: function($scope) {

                    function enableQuestionsForSelectedAnswer(enableQuestion) {
                        var answer = $scope.answer;

                        // if answer.QuestionsToTrigger collection is empty, do not fire enable event
                        _.forEach(answer.QuestionsToTrigger, function(questionToEnable) {
                            if (questionToEnable !== '00000000-0000-0000-0000-000000000000') {
                                $rootScope.$broadcast('FormAnswerChanged',
                                    {
                                        EnableQuestion: enableQuestion,
                                        QuestionIdToTrigger: questionToEnable
                                    });
                            }
                        });
                    }


                    $scope.answerChanged = function answerChanged() {
                        var enableQuestion = false;
                        if ($scope.question.SelectedAnswerText > 0) {
                            enableQuestion = true;
                        }
                        enableQuestionsForSelectedAnswer(enableQuestion);
                    };


                    function loadView() {
                        $scope.question.SelectedAnswerId = $scope.answer.SurveyAnswerId;
                    }
                    loadView();
                }
            };
        }
    ]
);